import { DatePipe } from '@angular/common';

export const DAY_FORMAT = 'dd-MMM';
export const WEEK_FORMAT = '';
export const MONTH_FORMAT = 'MMM';
export const QUARTER_FORMAT = '';
export const YEAR_FORMAT = 'yyyy';

/* It extends the DatePipe class and adds some methods to format dates */
export class DateFormatter extends DatePipe {
  constructor(locale?: string) {
    super(locale || 'es-GT');
  }

  /**
   * It takes a date, and returns a string
   * @param {Date} date - Date - The date to be formatted
   * @returns A string or null
   */
  getDayString(date: Date, format?: string): string | null {
    return this.transform(date, format || DAY_FORMAT);
  }

  /**
   * It takes a date and returns the month a string
   * @param {Date} date - Date - The date to be formatted
   * @returns A string or null
   */
  getMonthString(date: Date, format?: string): string | null {
    return this.transform(date, format || MONTH_FORMAT);
  }

  /**
   * If the date is not null, return the date formatted as a year string, otherwise
   * return null.
   * @param {Date} date - Date - The date to be formatted
   * @returns A string or null.
   */
  getYearString(date: Date): string | null {
    return this.transform(date, YEAR_FORMAT);
  }

  /**
   * It returns the week number of the month for a given date.
   * @param {Date} date - The date to get the week of.
   * @returns The week number of the month.
   */
  getWeekNumberOfMonth(date: Date): number {
    const firstDay = new Date(date.getFullYear(), date.getMonth(), 1).getDay();
    return Math.ceil((date.getDate() + (firstDay - 1)) / 7);
  }
  /**
   * It takes a date object and returns a string in the format of "Q1-2018" or
   * "Q2-2018" or "Q3-2018" or "Q4-2018"
   * @param {Date} date - Date - The date object to get the quarter from
   * @returns A string that is the quarter and year of the date passed in.
   */

  getMonthQuarterString(date: Date): string {
    const quarter = this.getQuarterByMonthIndex(date.getMonth());
    return `Q${quarter}-` + date.getFullYear();
  }

  /**
   * "Given a month index, return the quarter number."
   *
   * The function is a little more complicated than that, but that's the gist of it
   * @param {number} index - number - The index of the month in the year.
   * @returns The quarter number of the month.
   */
  private getQuarterByMonthIndex(index: number) {
    let quarterNumber: number;

    switch (index) {
      case 0:
      case 1:
      case 2:
        quarterNumber = 1;
        break;
      case 3:
      case 4:
      case 5:
        quarterNumber = 2;
        break;
      case 6:
      case 7:
      case 8:
        quarterNumber = 3;
        break;
      case 9:
      case 10:
      case 11:
        quarterNumber = 4;
        break;
      default:
        quarterNumber = 0;
    }

    return quarterNumber;
  }
}
